import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  NotifyOptions,
  NotifyResponse,
  notify as universalNotify,
} from './ping-notifications-v3-notification-notifications-v-3.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/notifications' };

export function notify(httpClient: HttpClient): NotifySignature {
  return (notificationTemplateId: string, options?: NotifyOptions) =>
    universalNotify(
      notificationTemplateId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface NotifySignature {
  /**
   * Sends notifications based on the template and dynamic values provided.
   *
   * > **Note**: An app can call this method up to 100,000 times per month for each site.
   *
   * When you create a [notification template](https://dev.wix.com/docs/rest/business-management/notifications/notifications/creating-a-notification-template), you are provided with a notification template ID. Call the Notify method with this ID as `notificationTemplateID` to trigger notifications based on that template.
   *
   * If the notification template contains placeholders for dynamic values, provide those values as key-value pairs in the `dynamicValues` array. The values you specify are incorporated in the notifications sent out.
   * @param - Notification template ID. A notification template specifies the text and recipients for notifications.
   * To obtain a notification template ID, create a notification template in your [app's dashboard](https://dev.wix.com/docs/build-apps/develop-your-app/app-dashboard-setup/about-the-app-dashboard).
   */
  (notificationTemplateId: string, options?: NotifyOptions): Promise<
    NonNullablePaths<NotifyResponse, `notificationBatchId`, 2>
  >;
}

export {
  ArrayDynamicValue,
  AttachmentDynamicValue,
  ChannelsContent,
  ChannelsData,
  DynamicValue,
  DynamicValueOfTypeOneOf,
  EmailData,
  ExcludedAudiences,
  MapDynamicValue,
  MobileContent,
  Money,
  Notification,
  NotifyByAppRequest,
  NotifyByAppResponse,
  NotifyOptions,
  NotifyRequest,
  NotifyResponse,
  Overrides,
  ResolveRequest,
  ResolveResponse,
  TemplateChannel,
} from './ping-notifications-v3-notification-notifications-v-3.universal.js';
